import { Box, Checkbox, FormControlLabel, Grid, Typography } from "@material-ui/core";
import { useFormik } from "formik";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import { createPreviousGateEntryDocs } from "src/app-redux/vehicle/actions/vehicleActions";
import {
  currentSelectedGatePassId,
  existingGateEntryDocs,
} from "src/app-redux/vehicle/vehicleSlice";
import CommonButton from "src/components/CommonButton/CommonButton";
import { useStyles } from "./style";
import IconButton from "@mui/material/IconButton";
import NoRecordFound from "src/components/NoRecordFound";
import img from "src/assets/images/file_formats_logos/img.svg";
import doc from "src/assets/images/file_formats_logos/doc.svg";
import pdf from "src/assets/images/file_formats_logos/pdf.svg";
import xlsx from "src/assets/images/file_formats_logos/xlsx.svg";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { downloadFile } from "src/app-redux/common-actions";

export interface IDrawerFilesProps {
  closeDrawer: () => void;
}

export default function DrawerFiles(props: IDrawerFilesProps) {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const selectedGatePassId: any = useAppSelector(currentSelectedGatePassId);
  const [selectedDocIds, setSelectedDocsIds] = useState<any[]>([]);

  const existingDocsList = useAppSelector(existingGateEntryDocs);

  const formik = useFormik<any>({
    enableReinitialize: true,
    initialValues: {
      gateEntryId: selectedGatePassId || 0,
      gateEntryDocIds: [],
    },
    onSubmit: async (values: any, actions) => {
      const res: any = await dispatch(
        createPreviousGateEntryDocs({ ...values, gateEntryDocIds: selectedDocIds })
      );
      if (res) {
        props.closeDrawer();
        actions.setSubmitting(false);
        formik.resetForm();
        formik.setValues(formik.initialValues);
        return;
      }
    },
  });

  const downloadDocument = async (item: any) => {
    const type =
      item.fileCategory === "Scan"
        ? 2
        : item.fileCategory === "Weight"
        ? 3
        : item.fileCategory === "Commercial"
        ? 4
        : 1;
    const fileMetaData = {
      url: `${process.env.REACT_APP_API_URL}/get-gate-doc-by-id/${item.id}?docType=${type}`,
      contentType: ".jpg",
      fileName: item.title,
    };
    dispatch(downloadFile(fileMetaData));
  };

  return (
    <div className={classes.drawerDetails}>
      {/* Drawer Status Item  */}

      <Grid container spacing={2} className="topContainer" style={{ marginTop: "5px" }}>
        <Grid container direction="row" className="itemRow" spacing={2}>
          <Grid
            item
            md={10}
            id="main-div"
            className={classes.drawerDetails}
            style={{
              height: "max-content",
            }}
          >
            {/* History Item  */}
            {existingDocsList.length !== 0 ? (
              existingDocsList.map((item: any, index: any) => (
                <>
                  <Grid container direction="row" className="itemRowTrail">
                    <Grid md={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            onChange={(e) => {
                              const arr = selectedDocIds;
                              e.target.checked
                                ? arr.push(item.id)
                                : arr.splice(arr.indexOf(item.id), 1);
                              setSelectedDocsIds(arr);
                            }}
                            name={index}
                            color={"primary"}
                          />
                        }
                        label=""
                      />
                    </Grid>
                    <Grid md={2} style={{ padding: "5px" }}>
                      <img
                        src={
                          item.extension === "doc" || item.extension === "docx"
                            ? doc
                            : item.extension === "jpg" ||
                              item.extension === "jpeg" ||
                              item.extension === "png"
                            ? img
                            : item.extension === "pdf"
                            ? pdf
                            : item.extension === "xlsx"
                            ? xlsx
                            : img
                        }
                        alt={item.extension}
                        width="25px"
                      />
                    </Grid>
                    <Grid md={6} style={{ paddingTop: "8px" }}>
                      <Typography className="subHeading itemName">{item.fileCategory}</Typography>
                    </Grid>
                    <Grid md={2}>
                      <IconButton
                        onClick={() => {
                          downloadDocument(item);
                        }}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                </>
              ))
            ) : (
              <div style={{ marginTop: "20px" }}>
                <NoRecordFound />
              </div>
            )}
          </Grid>

          <Grid container item xs={12} md={12}>
            <Grid item xs={12} md={9}>
              <Box textAlign="left" mt={1}>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => {
                    formik.submitForm();
                  }}
                >
                  Save
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
